import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "col w-full h-full gap-04" }
const _hoisted_2 = { class: "w-full row mtop-04" }
const _hoisted_3 = { class: "col w-full" }
const _hoisted_4 = { class: "col w-full" }
const _hoisted_5 = { class: "rowend w-full gap-08" }
const _hoisted_6 = { class: "es-planning mtop-10 w-full h-full" }
const _hoisted_7 = {
  key: 0,
  class: "w-full h-full rowcenter gap-08"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "rowcenter" }
const _hoisted_11 = { class: "row pad-m gap-08" }
const _hoisted_12 = { class: "col-0-13-5 w-full" }
const _hoisted_13 = { class: "font-m font-bold-600" }
const _hoisted_14 = { class: "col-0-5" }
const _hoisted_15 = { class: "font-m font-bold-600" }
const _hoisted_16 = { class: "row pad-m gap-08" }
const _hoisted_17 = { class: "col-0-13-5 w-full" }
const _hoisted_18 = { class: "col-1-5" }
const _hoisted_19 = { class: "row gap-06" }
const _hoisted_20 = { class: "col-0-6" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  key: 0,
  class: "tooltip mleft-08"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "tooltiptext-left tooltiptext-alert mtop-15 font-s" }
const _hoisted_25 = { class: "rowcenter" }

import { ApiError, CreateTimeslotsRequest, PersonLightResponse, SettingsApi, TimeslotDeleteRequest, TimeslotResponse, TimeslotResponsePaginated, TimeslotUpdatePeriodRequest, WeekModelByNameResponse, WeekModelIdsRequest, WeekModelResponse } from '@/apiGenerate/medserver';
import { ref, computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import EsWeekModelSettings from '@/components/modals/settings/esWeekModelSettings.vue';
import EsAddTimeslot from '@/components/modals/settings/esAddTimeslot.vue';
import SharedService from "@/services/SharedService";
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useAppUserStore } from '@/stores/appUser';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { DateFormat, ItemButtonGroup, SmallPageableDefault } from "@/models/share.model";
import Select from 'primevue/select';
import Checkbox from 'primevue/checkbox';
import EsConfirmDialog from "@/components/modals/esConfirmDialog.vue";
import { format } from 'date-fns';
import EsPaginator from '@/components/share/esPaginator.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'esPlanningSettings',
  props: {
    selectedInstituteId: {},
    refreshData: { type: Boolean },
    selectedHealthPro: {}
  },
  emits: ['week-model-changed'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();
const toast = useToast();
const appUserStore = useAppUserStore();

const settingsApi = new SettingsApi(medServerApiConfig);

const emits = __emit;

const isAddTimeslotOpened = ref<boolean>(false);
const isManageWeekModelOpened = ref<boolean>(false);
const weekModelByNames = ref<WeekModelByNameResponse[]>([]);
const timeslotIdsToDelete = ref<Record<string, boolean>>({});
const selectedTimeslot = ref<TimeslotResponse>(undefined);
const allTimeslotsSelected = ref<boolean>(false);
const loadingTimeslot = ref<boolean>(false);
const isConfirmOpened = ref<boolean>(false);
const headerConfirm = ref<string>(undefined);
const messageConfirm = ref<string>(undefined);
const timeslotsPaginated = ref<TimeslotResponsePaginated>({
    pageable: SmallPageableDefault,
    totalCount: 0,
    timeslots: []
})

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const getIconDeleteSelectedButton = computed ((): ItemButtonGroup => {
  return {
    codeAction: 'es-button-delete-selected',
    icon: 'trash',
    pathIcon: 'settings'
  };
})

const setIsManageWeekModelOpened = () => {
    isManageWeekModelOpened.value = true;
}

const closeWeekModelModal = () => {
    isManageWeekModelOpened.value = false;
    findWeekModelByInstitute();
}

const setIsAddTimeslotOpened = () => {
    isAddTimeslotOpened.value = true;
}

const closeAddTimeslotModal = async (createTimeslotsRequest: CreateTimeslotsRequest) => {
    if (createTimeslotsRequest) {
        if (props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
            await settingsApi.addTimeslots({instituteId: props.selectedInstituteId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value, createTimeslotsRequest: createTimeslotsRequest})
                .then(async () => {
                    toastSuccess(toast, {
                        summary: t('common.toast.success.add'),
                        detail:  t('settings.label.planning.message.success.add')
                    });
                    isAddTimeslotOpened.value = false;
                    refresh();
                }).catch((error: ApiError) => {
                    toastError(toast, {
                        summary: t('common.toast.error'),
                        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
                    });

                    // Throw error to set at false the var __alreadyClicked in v-one-click directive
                    throw error;
                });
            
        }
    } else {
        isAddTimeslotOpened.value = false;
    }
}

const findTimeslotByInstitute = async () => {
  if (props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
     await settingsApi.findTimeslotsByInstitute({instituteId: props.selectedInstituteId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value,
        start: timeslotsPaginated.value.pageable.start, limit: timeslotsPaginated.value.pageable.limit
     })
        .then((result: TimeslotResponsePaginated) => {
            timeslotsPaginated.value = result;
            updateAllTimeslotIdsToDelete();
        }).catch((error: ApiError) => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
            });
        });
    
  }
}

const findWeekModelByInstitute = async () => {
  if (props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
     await settingsApi.findWeekModelByInstitute({instituteId: props.selectedInstituteId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value})
      .then((result: WeekModelByNameResponse[]) => {
        weekModelByNames.value = result;
      }).catch((error: ApiError) => {
          toastError(toast, {
              summary: t('common.toast.error'),
              detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
          });
      });
  }
}

const deleteTimeslot = (timeslot: TimeslotResponse) => {
    isConfirmOpened.value = true;
    headerConfirm.value = t('settings.label.planning.modale.delete.header');
    messageConfirm.value = t('settings.label.planning.modale.delete.message');

    selectedTimeslot.value = timeslot;
}

const deleteTimeslotSelected = () => {
    selectedTimeslot.value = undefined;
    isConfirmOpened.value = true;
    headerConfirm.value = t('settings.label.planning.modale.deleteSelected.header');
    messageConfirm.value = t('settings.label.planning.modale.deleteSelected.message');
}

const updateAllTimeslotIdsToDelete = () => {
    timeslotsPaginated.value.timeslots.forEach((timeslot: TimeslotResponse) => {
        timeslotIdsToDelete.value[timeslot.timeslotId] = allTimeslotsSelected.value;
    });
}

const updateTimeslotIdsToDelete = () => {
    allTimeslotsSelected.value = Object.values(timeslotIdsToDelete.value).filter((value) => value).length === timeslotsPaginated.value.timeslots.length;
}

const refresh = async (weekModelChanged: boolean) => {
    selectedTimeslot.value = undefined;
    allTimeslotsSelected.value = false;
    await updateAllTimeslotIdsToDelete();
    await findTimeslotByInstitute();
    emits('week-model-changed', weekModelChanged);
}

const closeConfirm = (confirm: boolean) => {
    isConfirmOpened.value = false;
    if (confirm && props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
        if (selectedTimeslot.value) {
            settingsApi.deleteTimeslotById({instituteId: props.selectedInstituteId, timeslotId: selectedTimeslot.value.timeslotId, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value})
                .then(() => {
                    toastSuccess(toast, {
                        summary: t('common.toast.success.delete'),
                        detail:  t('settings.label.planning.message.success.delete')
                    });
                    refresh(true);
                }).catch((error: ApiError) => {
                    toastError(toast, {
                        summary: t('common.toast.error'),
                        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
                    });

                    // Throw error to set at false the var __alreadyClicked in v-one-click directive
                    throw error;
                });
        } else {
            const timeslotDeleteRequest: TimeslotDeleteRequest = {
                timeslotIds: (Object.keys(timeslotIdsToDelete.value) as Array<string>).filter(key => timeslotIdsToDelete.value[key] === true)
            }

            settingsApi.deleteTimeslotsByIds({instituteId: props.selectedInstituteId, timeslotDeleteRequest: timeslotDeleteRequest, doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value})
                .then(() => {
                    toastSuccess(toast, {
                        summary: t('common.toast.success.delete'),
                        detail:  t('settings.label.planning.message.success.delete')
                    });
                    refresh(true);
                }).catch((error: ApiError) => {
                    toastError(toast, {
                        summary: t('common.toast.error'),
                        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
                    });

                    // Throw error to set at false the var __alreadyClicked in v-one-click directive
                    throw error;
                });
        }
    }
}

const updateWeekModel = (timeslot: TimeslotResponse, newValue: WeekModelByNameResponse) => {
    if (timeslot.timeslotId && newValue?.weekModels && props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
        const weekModelIdsRequest: WeekModelIdsRequest = {
            weekModelIds: newValue.weekModels.map((weekModel: WeekModelResponse) => weekModel.weekModelId)
        }
        settingsApi.updateWeekModelTimeslotById({instituteId: props.selectedInstituteId, timeslotId: timeslot.timeslotId,
                                                    weekModelIdsRequest: weekModelIdsRequest, 
                                            doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value})
            .then(() => {
            toastSuccess(toast, {
                summary: t('common.toast.success.update'),
                detail:  t('settings.label.planning.message.success.update')
            });
            refresh(true);
        }).catch((error: ApiError) => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
            });
        });
    }
}

const updateDate = (timeslot: TimeslotResponse, newStartDate: Date, newEndDate: Date) => {
  if (!newStartDate || !newEndDate || (new Date(timeslot.startDate) === newStartDate && new Date(timeslot.endDate) === newEndDate)) {
    return;
  }

  const timeslotUpdatePeriodRequest: TimeslotUpdatePeriodRequest = {
    startDate: format(new Date(newStartDate), DateFormat.ISO_SMALL),
    endDate: format(new Date(newEndDate), DateFormat.ISO_SMALL)
  }

  if (timeslot.timeslotId && props.selectedInstituteId && (currentPersonId.value || props.selectedHealthPro?.id)) {
    settingsApi.updatePeriodTimeslotById({instituteId: props.selectedInstituteId, timeslotId: timeslot.timeslotId,
                                            timeslotUpdatePeriodRequest: timeslotUpdatePeriodRequest, 
                                            doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value})
        .then(() => {
            toastSuccess(toast, {
                summary: t('common.toast.success.update'),
                detail:  t('settings.label.planning.message.success.update')
            });
            refresh(true);
        }).catch((error: ApiError) => {
            toastError(toast, {
                summary: t('common.toast.error'),
                detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
            });
        });
  }
}
const prevPageable = async () => {
    timeslotsPaginated.value.pageable.start =  timeslotsPaginated.value.pageable.start - timeslotsPaginated.value.pageable.limit;
    refresh(false);
}

const nextPageable = async () => {
    timeslotsPaginated.value.pageable.start =  timeslotsPaginated.value.pageable.start + timeslotsPaginated.value.pageable.limit;
    refresh(false);
}

watch(
    () => props.selectedInstituteId,
  () => {
    refresh(false);
  }
)

watch(
  () => props.selectedHealthPro,
  () => {
    refresh(false);
  }
)

watch(
    () => props.refreshData,
    () => {
        if (props.refreshData) {
            refresh(false);
        }
    }
)

onMounted(() => {
  refresh(false);
  findWeekModelByInstitute();
});


return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (timeslotsPaginated.value.timeslots?.length > 0 && Object.values(timeslotIdsToDelete.value).filter((value) => value).length> 0)
            ? (_openBlock(), _createBlock(_component_es_button, {
                key: 0,
                "icon-content-button": getIconDeleteSelectedButton.value,
                label: _unref(t)('settings.label.planning.action.deleteSelected'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteTimeslotSelected())),
                "is-primary": false,
                "is-linked": true,
                styles: 'font-m txt-primary',
                iconStyles: 'img-primary'
              }, null, 8, ["icon-content-button", "label"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_es_button, {
              label: _unref(t)('settings.label.planning.action.openWeekModel'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setIsManageWeekModelOpened())),
              "is-primary": true
            }, null, 8, ["label"]),
            _createVNode(_component_es_button, {
              label: _unref(t)('settings.label.planning.action.addTimeslot'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (setIsAddTimeslotOpened())),
              "is-primary": true
            }, null, 8, ["label"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!timeslotsPaginated.value.timeslots || timeslotsPaginated.value.totalCount === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("img", {
                src: _unref(SharedService).getIcon('info-circle', false, 'shareIcons'),
                class: "square-14"
              }, null, 8, _hoisted_8),
              _createElementVNode("span", null, _toDisplayString(_unref(t)('settings.label.planning.noData')), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (timeslotsPaginated.value.totalCount > timeslotsPaginated.value.pageable.limit)
                  ? (_openBlock(), _createBlock(EsPaginator, {
                      key: 0,
                      currentRef: 'paginator-timeslot-top',
                      pageable: timeslotsPaginated.value.pageable,
                      total: timeslotsPaginated.value.totalCount,
                      loading: loadingTimeslot.value,
                      paginatorClass: 'w-350 bg-paginator',
                      onPrevPage: _cache[3] || (_cache[3] = ($event: any) => (prevPageable())),
                      onNextPage: _cache[4] || (_cache[4] = ($event: any) => (nextPageable())),
                      class: "mbottom-10 w-350"
                    }, null, 8, ["pageable", "total", "loading"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(Checkbox), {
                  binary: "",
                  modelValue: allTimeslotsSelected.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((allTimeslotsSelected).value = $event)),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (updateAllTimeslotIdsToDelete()))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)('settings.label.planning.column.slot')), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('settings.label.planning.column.weekModel')), 1)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeslotsPaginated.value.timeslots, (timeslot, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_unref(Checkbox), {
                      binary: "",
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (updateTimeslotIdsToDelete())),
                      modelValue: timeslotIdsToDelete.value[timeslot.timeslotId],
                      "onUpdate:modelValue": ($event: any) => ((timeslotIdsToDelete.value[timeslot.timeslotId]) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_esInputDateTime, {
                        dateTimeValue: [new Date(timeslot.startDate), new Date(timeslot.endDate)],
                        dateFormat: _unref(DateFormat).DATEPICKER,
                        withTime: false,
                        range: true,
                        minDate: new Date(),
                        size: "small",
                        onUpdateDateTime: ([start, end]: Date[]) => updateDate(timeslot, start, end)
                      }, null, 8, ["dateTimeValue", "dateFormat", "minDate", "onUpdateDateTime"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_unref(Select), {
                        "model-value": timeslot.weekModel,
                        options: weekModelByNames.value,
                        size: "small",
                        class: "w-full",
                        optionLabel: "name",
                        onValueChange: ($event: any) => (updateWeekModel(timeslot, $event))
                      }, _createSlots({ _: 2 }, [
                        (timeslot.weekModel)
                          ? {
                              name: "value",
                              fn: _withCtx((slotProps) => [
                                _createElementVNode("div", _hoisted_19, _toDisplayString(slotProps.value.name), 1)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["model-value", "options", "onValueChange"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_es_button_icon, {
                          icon: "trash",
                          folder: "settings",
                          onClick: ($event: any) => (deleteTimeslot(timeslot))
                        }, null, 8, ["onClick"]),
                        (timeslot.specialDayExist)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("img", {
                                src: _unref(SharedService).getIcon('exclamationmark-triangle', true, 'shareIcons'),
                                class: "img-red icon-container-16"
                              }, null, 8, _hoisted_23),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('settings.label.planning.tooltip')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_25, [
                (timeslotsPaginated.value.totalCount > timeslotsPaginated.value.pageable.limit)
                  ? (_openBlock(), _createBlock(EsPaginator, {
                      key: 0,
                      currentRef: 'paginator-timeslot-bottom',
                      pageable: timeslotsPaginated.value.pageable,
                      total: timeslotsPaginated.value.totalCount,
                      loading: loadingTimeslot.value,
                      onPrevPage: _cache[8] || (_cache[8] = ($event: any) => (prevPageable())),
                      onNextPage: _cache[9] || (_cache[9] = ($event: any) => (nextPageable())),
                      class: "mtop-10 w-350"
                    }, null, 8, ["pageable", "total", "loading"]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ]),
    _createVNode(EsWeekModelSettings, {
      selectedInstituteId: _ctx.selectedInstituteId,
      isOpen: isManageWeekModelOpened.value,
      "refresh-data": _ctx.refreshData,
      selectedHealthPro: _ctx.selectedHealthPro,
      onModalClose: _cache[10] || (_cache[10] = ($event: any) => (closeWeekModelModal())),
      onWeekModelChanged: _cache[11] || (_cache[11] = ($event: any) => (emits('week-model-changed', true))),
      header: _unref(t)('settings.label.planning.weekModel.header')
    }, null, 8, ["selectedInstituteId", "isOpen", "refresh-data", "selectedHealthPro", "header"]),
    _createVNode(EsAddTimeslot, {
      selectedInstituteId: _ctx.selectedInstituteId,
      isOpen: isAddTimeslotOpened.value,
      "refresh-data": _ctx.refreshData,
      selectedHealthPro: _ctx.selectedHealthPro,
      header: _unref(t)('settings.label.planning.modale.addTimeslot.header'),
      confirmMethod: closeAddTimeslotModal,
      onModalClose: _cache[12] || (_cache[12] = ($event: any) => ( isAddTimeslotOpened.value = false))
    }, null, 8, ["selectedInstituteId", "isOpen", "refresh-data", "selectedHealthPro", "header"]),
    _createVNode(EsConfirmDialog, {
      isOpen: isConfirmOpened.value,
      onModalClose: _cache[13] || (_cache[13] = () => closeConfirm(false)),
      header: headerConfirm.value,
      message: messageConfirm.value,
      "on-confirm": () => closeConfirm(true)
    }, null, 8, ["isOpen", "header", "message", "on-confirm"])
  ], 64))
}
}

})